import React from "react";
import { useAuth } from "@homesusa/auth";
import { getImpersonationStatus } from "core/services/user.service";

const ATTEMPT_KEY = "impersonation-signin-attempted";

export function ImpersonationUserRefresh(): null {
  const { user, signinRedirect } = useAuth();
  const attempted = React.useRef(false);
  const userId = user?.id;
  const impersonating = user?.isImpersonating === true;
  const attemptKey = userId ? `${ATTEMPT_KEY}:${userId}` : ATTEMPT_KEY;

  React.useEffect(() => {
    if (!userId || attempted.current) {
      return;
    }

    attempted.current = true;

    getImpersonationStatus()
      .then(({ isImpersonating }) => {
        if (isImpersonating === impersonating) {
          sessionStorage.removeItem(attemptKey);
          return;
        }

        if (sessionStorage.getItem(attemptKey) !== null) {
          return;
        }

        sessionStorage.setItem(attemptKey, "true");
        return signinRedirect();
      })
      .catch((error: unknown) => {
        sessionStorage.removeItem(attemptKey);
        console.error("The impersonated session could not be synchronised:", error);
      });
  }, [userId, attemptKey, impersonating, signinRedirect]);

  return null;
}
